module.exports = __webpack_public_path__ + "ph.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ph.svg
// module id = 755
// module chunks = 0